export const standardFilterFields = [
	'principalId',
	'principalType',
	'countryCode',
	'organizationId',
] as const;

export const filterFields = [...standardFilterFields] as const;
